$(document).ready(function() {
    
    let $accordionBtn = $('#quiz-results-accordion .accordion-question');
    if($accordionBtn.length){
        $accordionBtn.click(function(){
            let $this = $(this);
            let $accordion = $this.closest('.accordion-item');
            let $accordionContent = $accordion.find('.accordion-content');
            $accordionContent.stop().slideToggle(400);
            $accordion.toggleClass('open');
        });
    }

    let $ctaAddToCartBtn = $('#cta-product-add-to-cart');
    if($ctaAddToCartBtn.length){
        $ctaAddToCartBtn.click(function(){
            let formData = {
                'items': [
                    {
                        'id': this.dataset.variantid,
                        'quantity': 1
                    }
                ]
            };
    
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {'content-Type': 'application/json'},
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });
    }
});

// CF.customerReady(function() {
//     console.log('****** CUSTOMER READY! *******')
//     let petDataFromMetafield = window.CF.customer.get('pet_data');
//     if(petDataFromMetafield){
//         console.log('set LS from metafield', petDataFromMetafield);
//         localStorage.setItem('currentPetIndex', 0);
//         localStorage.setItem('petData', petDataFromMetafield);	
//     }
// });